import React from 'react';
import { Layout, Button, Divider } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import {
	approveInvoiceForSupplier,
	createInvoiceSubContractor,
	getContractorInvoices,
	invoicesSubcontractorRestCrudThunks,
	invoicesRestCrudThunksForSupplier,
	updateInvoiceSubContractor,
	invoicesClientRestCrudThunks,
} from '../../thunks/invoices_thunks';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { EmptyState } from '../empty_state/EmptyState';
import {
	appendWorkOrderNotesForSupplier,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import SupplierInvoiceDetailDetailsPageWrapper from '../supplier_invoice_detail_details_page_wrapper/SupplierInvoiceDetailDetailsPageWrapper';
import { getContractorWO, getSanitisedWorkOrder } from '../../utils/WorkOrderUtils';
import OWLink from '../OWLink';
import NewSupplierInvoicePageV2 from '../new_supplier_invoice_page/NewSupplierInvoicePageV2';
import NewBuyerInvoicePageV2 from '../new_buyer_invoice_page/NewBuyerInvoicePageV2';

const { Content } = Layout;

require('./SupplierWorkOrdersDetailInvoicesPage.less');

class SupplierWorkOrderInvoicesDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			generatingPDF: false,
			isGreaterThanNTE: false,
			invoiceExists: false,
			copyInvoice: {},
			editingInvoice: false,
			loading: false,
		};
	}

	refreshInvoice = () => {
		const { getInvoices, match, workOrder, isClientView, getContractorInvoices } = this.props;
		const workOrderId = match.params.id;

		const contractorWO = getContractorWO(workOrder, isClientView);
		const params = contractorWO ? { contractorWorkOrderId: contractorWO.id } : { workOrderId };

		const action = contractorWO ? getContractorInvoices : getInvoices;

		return action(params, 'workOrderAssociatedInvoices');
	};

	componentDidMount() {
		const {
			getInvoices,
			match,
			getCount,
			getContractorInvoices,
			getWorkOrder,
			isClientView,
			workOrder,
			getSubContractorInvoices,
		} = this.props;
		const workOrderId = match.params.id;

		const getInvoiceDetails = (workOrder) => {
			const contractorWO = getContractorWO(workOrder, isClientView);
			let params = {};
			if (contractorWO) {
				params = {
					contractorWorkOrderId: contractorWO.id,
					contractorSupplierFacilityId: contractorWO.contractorSupplierFacilityId,
				};
			} else {
				params = { workOrderId, supplierFacilityId: workOrder.supplierFacilityId };
			}

			const action = contractorWO
				? isClientView
					? getContractorInvoices
					: getSubContractorInvoices
				: getInvoices;
			action(params, 'workOrderAssociatedInvoices');
			getCount(workOrderId, 'draft').then((d) => this.setState({ invoiceExists: d > 0 }));
		};

		if (workOrder && workOrder.id) {
			getInvoiceDetails(workOrder);
		} else {
			getWorkOrder(workOrderId).then((data) => {
				getInvoiceDetails(data);
			});
		}
	}

	render() {
		const {
			workOrder,
			invoices,
			invoicesFetching,
			currentUser,
			match,
			isClientView,
			invoicesUpdating,
		} = this.props;
		const workOrderId = match.params.id;
		const isInternalTech = nullSafeGetOrElse('facility.status', currentUser, '') === 'private';

		const supplierFacilityId = nullSafeGet('facility.id', currentUser);

		const associatedInvoices = getRecordsForTargetCollection(
			invoices,
			'workOrderAssociatedInvoices'
		);

		const disableSimpleInvoiceEntry = nullSafeGetOrElse(
			'buyerCompany.buyerCompanySettings.config.suppliersConfig.disableSimpleInvoiceEntry',
			workOrder,
			false
		);

		const contractorWO = getContractorWO(workOrder, isClientView);

		const isEmptyState =
			associatedInvoices.some((invoice) => invoice.status === 'draft') && isInternalTech;

		const canSeeCreateCTA =
			(!isInternalTech ||
				(nullSafeGet('supplierFacilityId', workOrder) &&
					supplierFacilityId !== workOrder.supplierFacilityId)) &&
			(isClientView || isInternalTech);
		if (isEmptyState) {
			return (
				<EmptyState
					graphic={
						<img
							style={{ marginBottom: 8 }}
							src="https://s3.amazonaws.com/mock-data-assets/categories/images/bank terminal.svg"
							alt=""
						/>
					}
					headline={
						!isInternalTech
							? "You haven't billed for this work order yet."
							: "You haven't been billed for this work order yet."
					}
					body={
						<span>
							Your service provider has drafted an invoice, it just hasn't been published yet.
						</span>
					}
				/>
			);
		}
		if (invoicesFetching) {
			return <PageLoadingPlaceholder />;
		}

		let content = null;

		if (associatedInvoices.length > 0) {
			content = (
				<div>
					{associatedInvoices.map((invoice) => (
						<SupplierInvoiceDetailDetailsPageWrapper
							key={invoice.id}
							invoice={{ ...invoice, workOrder }}
							invoicesUpdating={invoicesUpdating}
							refreshInvoice={this.refreshInvoice}
							workOrder={getSanitisedWorkOrder(workOrder)}
							showViewInvoicePage={isClientView}
							isClientView={isClientView}
						/>
					))}
				</div>
			);
		} else if (canSeeCreateCTA) {
			content = (
				<AccessPermissionChecker
					name={PERMISSION_NAMES.CAN_UPLOAD_INVOICES_FOR_SUPPLIER}
					exclude3rdPartySuppliers
				>
					<div className="mx-auto mt-[150px] flex max-w-[50%] flex-col items-center justify-center gap-6">
						{isInternalTech ? <NewBuyerInvoicePageV2 /> : <NewSupplierInvoicePageV2 />}

						<Divider style={{ margin: 0 }}>
							<span className="text-character-secondary">OR</span>
						</Divider>

						<OWLink
							sameParent
							to={`/supplier/workOrders/detail/${workOrderId}/invoices/${
								isInternalTech ? 'newForSupplier' : 'new'
							}`}
						>
							<Button>Create from scratch</Button>
						</OWLink>
					</div>
				</AccessPermissionChecker>
			);
		} else {
			content = (
				<EmptyState
					graphic={
						<img
							style={{ marginBottom: 8 }}
							src="https://s3.amazonaws.com/mock-data-assets/categories/images/bank terminal.svg"
							alt=""
						/>
					}
					headline={
						isInternalTech || !isClientView
							? "You haven't been billed for this work order yet."
							: "You haven't billed for this work order yet."
					}
					body={
						canSeeCreateCTA ? (
							<AccessPermissionChecker
								name={PERMISSION_NAMES.CAN_UPLOAD_INVOICES_FOR_SUPPLIER}
								exclude3rdPartySuppliers
							>
								<div style={{ textAlign: 'center' }}>
									{isClientView || isInternalTech ? (
										<OWLink
											to={`/supplier/workOrders/detail/${workOrderId}/invoices/${
												isInternalTech ? 'newForSupplier' : 'new'
											}`}
											sameParent
											style={{ marginRight: 8 }}
										>
											<Button type="primary">Create invoice</Button>
										</OWLink>
									) : null}

									{!disableSimpleInvoiceEntry && !contractorWO ? (
										<OWLink
											to={`/supplier/workOrders/detail/${workOrderId}/invoices/createSimple`}
											style={{ marginRight: 8 }}
											sameParent
										>
											<Button>Upload invoice PDF</Button>
										</OWLink>
									) : null}
								</div>
							</AccessPermissionChecker>
						) : null
					}
				/>
			);
		}

		return (
			<AccessPermissionChecker name={PERMISSION_NAMES.CAN_VIEW_INVOICES} isPage>
				<Content className="invoicesDetailDetailsPage">{content}</Content>
			</AccessPermissionChecker>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	workOrdersFetching: state.work_orders.fetching,
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	invoicesFetching: state.invoices.fetching,
	invoices: state.invoices,
	invoicesCreating: state.invoices.creating,
	invoicesUpdating: state.invoices.updating,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
	isClientView: state.clientView.isClientView,
});

const mapDispatchToProps = (dispatch) => ({
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
	getInvoices: (params, targetCollectionName) =>
		dispatch(invoicesClientRestCrudThunks.read(params, targetCollectionName)),
	updateInvoice: (entity) => dispatch(invoicesRestCrudThunksForSupplier.update(entity)),
	createInvoice: (invoice) => dispatch(invoicesRestCrudThunksForSupplier.create(invoice)),
	getContractorInvoices: (params, targetCollectionName) =>
		dispatch(getContractorInvoices(params, targetCollectionName)),
	updateContractorInvoice: (entity) => dispatch(updateInvoiceSubContractor(entity)),
	getSubContractorInvoices: (params, targetCollectionName) =>
		dispatch(invoicesSubcontractorRestCrudThunks.read(params, targetCollectionName)),
	getSubContractorInvoice: (id) => dispatch(invoicesSubcontractorRestCrudThunks.readOne(id)),
	getCount: (workOrderId, status) =>
		dispatch(invoicesRestCrudThunksForSupplier.countBy({ workOrderId, status }, status)),
	appendWorkOrderNotes: (entity) => dispatch(appendWorkOrderNotesForSupplier(entity)),
	createContractorInvoice: (invoice) => dispatch(createInvoiceSubContractor(invoice)),
	approveInvoice: (invoice) => dispatch(approveInvoiceForSupplier(invoice)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierWorkOrderInvoicesDetailPage)
);
